import { clsx } from 'clsx';
import Loader from "../Loader";
import { KBORDERED_BTN_SIZE, KBTN_FILLED_SIZE, KBUTTON_CLASSES } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LoadingButton = function LoadingButton(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    _ref$isWhite = _ref.isWhite,
    isWhite = _ref$isWhite === void 0 ? false : _ref$isWhite,
    loaderDuration = _ref.loaderDuration,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading' : _ref$label;
  var hasWhiteMode = type === 'primary' || type === 'inverse';
  var isInverse = type.includes('inverse');
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    className: clsx('tw-inline-flex tw-items-center tw-gap-0.8',
    // DISPLAY
    hasWhiteMode && isWhite && 'tw-btn-white', KBUTTON_CLASSES[type], isInverse ? KBORDERED_BTN_SIZE[size] : KBTN_FILLED_SIZE[size]),
    children: [/*#__PURE__*/_jsx(Loader, {
      duration: loaderDuration,
      size: "xs",
      itemClass: "tw-bg-current"
    }), label]
  });
};
export default LoadingButton;